// eslint-disable-next-line @typescript-eslint/no-require-imports
const packages = require('../package.json')

/** @ignore */
export const metadata = {
	name: 'rainlink',
	version: packages ? packages : '1.0.0',
	github: 'https://github.com/RainyXeon/Rainlink',
}
